import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import './FileInputButton.less';

class FileInputButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);

    this.fileInputRef = React.createRef();

    this.state = {
      busy: false
    };
  }

  handleClick = () => {
    this.fileInputRef.current.click();
  };

  handleSelect(e) {
    const { onSelect, callback } = this.props;  // eslint-disable-line
    const file = e.target;
    if (file && file.files.length > 0) {
      this.setState({ busy: true });
      onSelect(file).then(() => {
        if (callback) {
          callback(); // call to check the checkbox and add to the recipient list on the right
        }
      });
    }
  }

  render() {
    const { inputId, types, btnClass, btnText, busyOverride, busy, disabledOverride } = this.props;
    const busySource = busyOverride ? busy : this.state.busy;

    return (
      <div className="file-input-button-container">
        <ButtonV2 component="button" onClick={this.handleClick} className={btnClass} disabled={busySource || disabledOverride}>{btnText || 'Upload'}</ButtonV2>
        <input type="file" ref={this.fileInputRef} id={inputId} onChange={this.handleSelect} disabled={busySource || disabledOverride} accept={types} />
      </div>
    );
  }
}

FileInputButton.propTypes = {
  onSelect: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  types: PropTypes.string.isRequired,
  btnClass: PropTypes.string,
  btnText: PropTypes.string,
  busy: PropTypes.bool,
  busyOverride: PropTypes.bool,
  disabledOverride: PropTypes.bool,
  callback: PropTypes.func,
};

export default FileInputButton;



// WEBPACK FOOTER //
// ./src/components/common/form/FileInputButton.jsx